exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".price-range .end,.price-range .start{width:120px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-b474d594!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PriceRange.vue
// module id = 829
// module chunks = 2